import { CountryPhoneSelector } from '@theme/country-phone-selector';
import { applyFormFieldLimits, bindB2bFormSubmit } from '@theme/b2b-form-submit';

const B2B_FORM_TYPES = new Set(['b2b', 'directions-workwith']);
const COUNTRY_FORM_SELECTOR = '[data-form-type="b2b"], [data-form-type="directions-workwith"], [data-form-type="callback"], [data-form-type="reserve-item"]';

export async function initCountryPhoneSelector(form) {
  if (!form || form.dataset.countryPhoneReady === 'true') return;

  const selector = CountryPhoneSelector.fromForm(form);
  if (!selector) return;

  form.dataset.countryPhoneReady = 'true';

  try {
    await selector.init();
  } catch (error) {
    console.warn('Country phone selector init failed', error);
  }

  applyFormFieldLimits(form);

  const formType = form.getAttribute('data-form-type');
  if (B2B_FORM_TYPES.has(formType)) {
    bindB2bFormSubmit(form, selector);
  }
}

function bootForm(form) {
  if (!form.querySelector('[data-country-phone], .b2b-country-selector, .am-popup__country-selector')) return;
  initCountryPhoneSelector(form);
}

function bootAll() {
  document.querySelectorAll(COUNTRY_FORM_SELECTOR).forEach(bootForm);
}

document.addEventListener('DOMContentLoaded', bootAll);

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches?.(COUNTRY_FORM_SELECTOR)) {
        bootForm(node);
        return;
      }
      node.querySelectorAll?.(COUNTRY_FORM_SELECTOR).forEach(bootForm);
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

window.initCountryPhoneSelector = initCountryPhoneSelector;
